export const STATS_CATEGORY = {
    KEY_STATS: 'Key Stats'
};

export const STATS_CATEGORY_ARRAY = [STATS_CATEGORY.KEY_STATS];

export const STATS_CATEGORY_LABELS = {
    'Key Stats': 'keyStats'
};
